var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("PageHeader", { attrs: { title: _vm.name, "no-padding": "" } }),
      _vm._v(" "),
      !_vm.loadingHasFinish
        ? _c("PageLoader", {
            staticClass: "my-5",
            attrs: { resourceName: "guideline" },
          })
        : _vm.currentGuideline
        ? [
            _vm.isTenantAdmin
              ? _c("TenantGuidelinesDetailForm", {
                  staticClass: "mb-3",
                  attrs: {
                    currentGuideline: _vm.currentGuideline,
                    name: _vm.name,
                    isAddpageForm: false,
                    isTenantEditable: _vm.isTenantEditable,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isTenantAdmin
              ? _c("TenantGuidelinesDetailStandards", {
                  attrs: {
                    currentGuideline: _vm.currentGuideline,
                    name: _vm.name,
                    isAddpageForm: false,
                    isTenantEditable: _vm.isTenantEditable,
                  },
                })
              : _vm._e(),
          ]
        : _c(
            "v-card",
            [
              _c(
                "v-card-title",
                [
                  _c(
                    "v-icon",
                    { staticClass: "mr-2", attrs: { color: "warning" } },
                    [_vm._v("warning")]
                  ),
                  _vm._v("\n      Guideline was not found.\n    "),
                ],
                1
              ),
            ],
            1
          ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }